import TemplateView from '../../../TemplateView'

export default class SettingsInfoHeader extends TemplateView {
    constructor({
        content,
        onCollapseChanged = (collapsed) => {},
    }) {
        super()

        this.content = content

        this.params = {
            onCollapseChanged,
        }

        this.state = {
            collapsed: false,
        }

        this.onStatePropertyChanged("collapsed", (collapsed) => {
            this.$el.toggleClass("expanded", !collapsed)
        })
    }

    templateHtml() {
        return '<div class="darSettingsInfoHeader">' +
               '  <div class="contentPlaceholder"></div>' +
               '  <div class="collapseButton">' +
               '    <div class="icon"></div>' +
               '    <div class="arrow"></div>' +
               '  </div>' +
               '</div>'
    }

    afterRender() {
        this.content = this.content.init(this.find(".contentPlaceholder"))
        this.$collapseButton = this.find(".collapseButton")
        this.$collapseButton.click(() => this.params.onCollapseChanged(!this.state.collapsed))
    }
}



// WEBPACK FOOTER //
// ./web/js/administration/darSettings/components/SettingsInfoHeader.js